import { Injectable } from '@angular/core';
import { Offices } from '@etoh/database/angular';
import { BehaviorSubject, lastValueFrom, take } from 'rxjs';
import { LOCALES_CODES } from '../locales/locales';
import { UserService } from '../user.service';
import { StoreService } from './store.service';

interface UserOffice extends Offices {
  locale: LOCALES_CODES;
}

@Injectable({
  providedIn: 'root',
})
export class UserOfficeService {
  userOffice$ = new BehaviorSubject<undefined | UserOffice>(undefined);

  constructor(private user: UserService, private storeService: StoreService) {
    this.user.userOfficeId$.subscribe(async (officeId) => {
      if (!officeId) {
        this.userOffice$.next(undefined);
      } else {
        const office = await lastValueFrom(
          this.storeService
            .getObjectFromStoreById<Offices>('offices', officeId)
            .pipe(take(1))
        );

        this.userOffice$.next(office as UserOffice);
      }
    });
  }
}
